import { filter, get, isEmpty, map, some, values } from 'lodash'

import { INGREDIENT_KEYWORD_SUBTYPES } from '../../common/constants'

const buildSubtypeNodesForMovedOrTransferedNode = (
  node,
  keywordType,
  nodeToMoveTo,
) => {
  const possibleSubtypes =
    nodeToMoveTo.level === 1
      ? values(INGREDIENT_KEYWORD_SUBTYPES)
      : get(
          INGREDIENT_KEYWORD_SUBTYPES,
          `${nodeToMoveTo.subtype}.childrenKeyTypes`,
        )

  const subtypesToCreateForNode = filter(
    possibleSubtypes,
    ({ id }) =>
      isEmpty(node.children) ||
      !some(node.children, ({ subtype }) => id === subtype),
  )

  return map(subtypesToCreateForNode, ({ id, term }) => ({
    id: `${node.id}-${id}`,
    term,
    subtype: id,
    level: nodeToMoveTo.level + 2,
    type: nodeToMoveTo.type,
    parentId: node.id,
    children: [],
    isSubtype: true,
    allowedOperations: keywordType.allowedOperations,
  }))
}

export default buildSubtypeNodesForMovedOrTransferedNode
